import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 page-fill" }
const _hoisted_2 = {
  class: "row w-full justify-between flex flex-shrink-0",
  style: {"align-items":"center"}
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex flex-row-reverse gap-3" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_7 = { class: "mt-5 flex flex-col flex-1 min-h-0 overflow-hidden" }
const _hoisted_8 = { class: "px-5 pb-5 card w-full mapping-tabs-shell min-h-0" }
const _hoisted_9 = { class: "pt-5 flex-shrink-0" }
const _hoisted_10 = { class: "table-section mt-5 min-h-0 flex-1 overflow-hidden" }
const _hoisted_11 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_12 = { class: "pl-2" }
const _hoisted_13 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_14 = { class: "formcontainer flex flex-col" }
const _hoisted_15 = {
  key: 0,
  class: "row flex flex-row w-full upperspacing"
}
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_19 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_20 = { class: "w-6/12" }
const _hoisted_21 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_22 = {
  key: 1,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_23 = { class: "w-3/6 leftspacing" }
const _hoisted_24 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_25 = {
  key: 1,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_26 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_27 = { class: "w-6/12" }
const _hoisted_28 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_29 = { class: "w-3/6 leftspacing" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  class: "text-xs font-extrabold mb-3 mt-2"
}
const _hoisted_32 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_33 = { class: "w-6/12" }
const _hoisted_34 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_35 = {
  key: 1,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_36 = { class: "w-3/6 leftspacing" }
const _hoisted_37 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_38 = {
  key: 1,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_39 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_40 = { class: "w-full" }
const _hoisted_41 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_42 = {
  key: 1,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_43 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_44 = { class: "w-full" }
const _hoisted_45 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_46 = {
  key: 1,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_47 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_48 = { class: "w-full" }
const _hoisted_49 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_50 = {
  key: 1,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_51 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_52 = { class: "w-full" }
const _hoisted_53 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_54 = {
  key: 1,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_55 = {
  key: 0,
  class: "buttonposition flex justify-center items-center my-4 mx-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "title" }, "Frameworks", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          type: "file",
          class: "hidden",
          accept: ".xls,.xlsx",
          ref: "file",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fileReader($event)))
        }, null, 544),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["flex", !_ctx.columnObject ? 'filterButton' : 'filterButtondisabled pointer-events-none']),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
          }, [
            (_ctx.columnObject)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : (_openBlock(), _createElementBlock("img", _hoisted_6)),
            _cache[6] || (_cache[6] = _createTextVNode(" Filters "))
          ], 2),
          (_ctx.selectedFrameName.displayName != 'Internal Controls')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btnprimary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.importDoc()))
              }, "Import"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-xs mt-3 flex-shrink-0" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ", -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_ctx.tabHead.length)
          ? (_openBlock(), _createBlock(_component_Tabs, {
              key: 0,
              value: _ctx.selectedFrame,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedFrame) = $event)),
              class: "h-full min-h-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_TabList, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                        return (_openBlock(), _createBlock(_component_Tab, {
                          key: tab.value,
                          value: tab.value,
                          onClick: ($event: any) => (_ctx.toggleTabs(tab.value))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tab.displayName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_tableData, {
                    class: "flex-1 min-h-0",
                    tableRowData: _ctx.tableRow,
                    headersData: _ctx.headers,
                    tableRouteArr: _ctx.optionsValue,
                    loadData: _ctx.dataLoading
                  }, null, 8, ["tableRowData", "headersData", "tableRouteArr", "loadData"])
                ])
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true),
        (_ctx.popUpFrameWork)
          ? (_openBlock(), _createBlock(_component_popup, {
              key: 1,
              popUp: _ctx.popUpFrameWork
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.frameworkObj.controlFrameWork || 'Internal Controls'), 1),
                  _createElementVNode("button", {
                    class: "float-right text-3xl",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCancelbtn()))
                  }, _cache[8] || (_cache[8] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "h-5 w-5 cursor-pointer"
                    }, null, -1)
                  ]))
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          (!Object.keys(_ctx.frameworkObj).includes(_ctx.isInternalControl) && _ctx.frameworkObj.isInternalControl == true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "controllabel" }, "Framework", -1)),
                                  (_ctx.frameworkObj.controlFrameWork != undefined || _ctx.frameworkObj.controlFrameWork != null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.frameworkObj.controlFrameWork), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString('N/A')))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "controllabel" }, "Number", -1)),
                              (_ctx.frameworkObj.controlNumber != undefined || _ctx.frameworkObj.controlNumber != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.frameworkObj.controlNumber), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString('N/A')))
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "controllabel" }, "Title", -1)),
                              (_ctx.frameworkObj.controlTitle != undefined || _ctx.frameworkObj.controlTitle != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.frameworkObj.controlTitle), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString('N/A')))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "controllabel" }, "Type", -1)),
                              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.frameworkObj?.controlType || 'N/A'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              (_ctx.frameworkObj.controlPriority!='')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createElementVNode("div", null, [
                                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Priority", -1)),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mb-3 mt-2 text-xs", _ctx.colorLabelBg(_ctx.frameworkObj.controlPriority)])
                                        }, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(_ctx.colorLabelText(_ctx.frameworkObj.controlPriority))
                                          }, _toDisplayString(_ctx.getProirityLabel(_ctx.frameworkObj.controlPriority)), 3)
                                        ], 2)
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_31, "N/A"))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "controllabel" }, "Family", -1)),
                              (_ctx.frameworkObj.controlFamily != undefined || _ctx.frameworkObj.controlFamily != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.frameworkObj.controlFamily), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString('N/A')))
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "controllabel" }, "Class", -1)),
                              (_ctx.frameworkObj.controlClass != undefined || _ctx.frameworkObj.controlClass != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.frameworkObj.controlClass), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString('N/A')))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                              (_ctx.frameworkObj.Description != undefined || _ctx.frameworkObj.Description != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.frameworkObj.Description), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString('N/A')))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "controllabel" }, "Tasks", -1)),
                              (_ctx.frameworkObj.controlMaintenanceTask != null || _ctx.frameworkObj.controlMaintenanceTask != undefined)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.frameworkObj.controlMaintenanceTask), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString('N/A')))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "controllabel" }, "Policies", -1)),
                              (_ctx.frameworkObj.controlPolicies != undefined || _ctx.frameworkObj.controlPolicies != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.frameworkObj.controlPolicies), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString('N/A')))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "controllabel" }, "Guidance", -1)),
                              (_ctx.frameworkObj.controlGuidance != undefined || _ctx.frameworkObj.controlGuidance != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.frameworkObj.controlGuidance), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString('N/A')))
                            ])
                          ])
                        ]),
                        (_ctx.deleteAccess === true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                              _createElementVNode("button", {
                                class: "btnprimary",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteCustomControl(_ctx.frameworkObj)))
                              }, "Delete")
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["popUp"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}